import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import ReactPlayer from 'react-player';

import { useDate } from '../../hooks/useDate';

const LDN = 'London';
const SF = 'San Francisco';
const liveStreamStart = 'liveStreamStart';
const liveStreamEnd = 'liveStreamEnd';

const VideoPlayer = ({ sourceUrl, playing, posterImage, location }) => {
  const scheduleQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        preliminarySchedule (
          options: {
            cachebust: true
          }
        ) {
          id
          data {
            location
            title
            start
            end
          }
        }
      }
    }
  `);

  const { date: currDate } = useDate(15); // refresh every 15 sec

  const [streamStart, setStreamStart] = useState({});
  const [streamEnd, setStreamEnd] = useState({});

  useEffect(() => {
    if (!scheduleQuery) {
      return;
    }

    const list = scheduleQuery?.allBuilderModels?.preliminarySchedule;

    let newStrStart = {};
    let newStrEnd = {};
    [LDN, SF].forEach((loc) => {
      list
        .filter((item) => item.data.location === loc)
        .forEach((ev) => {
          if (ev.data.title === liveStreamStart) {
            newStrStart[loc] = new Date(ev.data.start);
          } else if (ev.data.title === liveStreamEnd) {
            newStrEnd[loc] = new Date(ev.data.end);
          }
        });
    });
    setStreamStart(newStrStart);
    setStreamEnd(newStrEnd);
  }, [scheduleQuery]);

  const isLive = !location || (currDate >= streamStart[location] && currDate <= streamEnd[location]);

  if (!sourceUrl && !posterImage) {
      return <></>;
  }
  return (
    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
      {ReactPlayer.canPlay(sourceUrl) && isLive ? (
        <ReactPlayer
          url={sourceUrl}
          playing={playing}
          controls
          width='100%'
          height='100%'
          style={{ position: 'absolute', top: 0, left: 0 }}
          light={posterImage || false}
        />
      ) : posterImage ? (
        <img
          src={posterImage}
          alt='video player placeholder'
          width='100%'
          height='100%'
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      ) : null}
    </div>
  );
}

export default VideoPlayer;
